// import { useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";

// export default function Footer() {
//   const footerStyles = "p-6 bg-[#EFD05C] text-center";
//   const location = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top on every route change
//   }, [location]);

//   return (
//     <>
//       <div className={footerStyles}>
//         <h2 className="font-bold text-2xl my-4">Who Are We?</h2>
//         <p className="px-6 md:px-40 lg:px-64 text-gray-800">
//           Mega Cash Box is an exciting and interactive game that offers players
//           a thrilling experience of chance and reward. In this captivating game,
//           users are presented with six boxes, each potentially containing cash or surprises.
//         </p>

//         <div className="my-6">
//           <h2 className="font-bold text-2xl my-4">Our Partner</h2>
//           <div className="flex justify-center my-4">
//             <img src="caritas.svg" alt="caritas" className="mx-2 w-[82px]" />
//           </div>
//         </div>

//         <div className="flex flex-col md:flex-row justify-center gap-6 mb-6">
//           <Link className="underline text-[#061126] hover:text-[#ECA34D] transition-colors" to="/termsConditions">
//             Terms and Conditions
//           </Link>
//           <Link className="underline text-[#061126] hover:text-[#ECA34D] transition-colors" to="/privacypolicy">
//             Privacy Policy
//           </Link>
//         </div>
//       </div>

//       <div className="bg-white p-6 text-center font-bold">
//         <div className="flex flex-wrap justify-center items-center gap-6 mb-4">
//           <p className="flex items-center text-gray-700">
//             <span className="mr-2">Talk to us:</span>
//             <a href="tel:+233303980440" className="text-[#061126] hover:text-[#ECA34D] transition-colors">
//               +233(0)303980440
//             </a>
//           </p>
//           <p className="flex items-center text-gray-700">
//             <span className="mr-2">Email us at:</span>
//             <a
//               className="underline text-[#061126] hover:text-[#ECA34D] transition-colors"
//               href="mailto:contact@megacashluckybox.com"
//             >
//               contact@megacashluckybox.com
//             </a>
//           </p>
//         </div>

//         <p className="text-gray-700">
//           &copy; {new Date().getFullYear()} Copyright:
//           <Link
//             to="/"
//             className="underline text-[#061126] hover:text-[#ECA34D] transition-colors ml-1"
//           >
//             MegaCashBox
//           </Link>
//         </p>
//       </div>
//     </>
//   );
// }

// import { useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";

// export default function Footer() {
//   const footerStyles = " p-2 bg-[#EFD05C] text-center ";
//   const location = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top on every route change
//   }, [location]);

//   return (
//     <>
//       <div className={footerStyles}>

//         <h2 className="font-bold text-xl my-2">Who are we?</h2>
//         <p className=" px-0 md:px-80">
//           Mega Cash Box is an exciting and interactive game that offers players
//           a thrilling experience of chance and reward.In this captivating game,
//           users are presented with six boxes, each potentially containing cash
//           or suprises.{" "}
//         </p>
//         <div className=" ">
//           <h2 className="font-bold text-xl my-2">Our partner</h2>
//           <div className="flex justify-center my-2">

//             <img src="caritas.svg" alt="caritas" className="mx-2 w-[82px]" />
//           </div>
//         </div>
//         <p className="mx-6 md:inline-block">
//           <Link
//             className="underline text-[#061126]"
//             to="/termsConditions">
//             Terms and Conditions
//           </Link>
//         </p>
//         <Link
//           className="underline text-[#061126]"
//           to="/privacypolicy">
//           Privacy Policy
//         </Link>
//       </div>
//       <div className="bg-white p-4 text-center font-bold">
//         <div className="flex flex-wrap justify-center items-center gap-4 mb-2">
//           <p className="flex items-center">
//             <span className="mr-2">Talk to us</span>
//             <a href="tel:+233303980440" className="text-[#061126] hover:text-[#EFD05C] transition-colors">
//               +233(0)303980440
//             </a>
//           </p>
//           <p className="flex items-center">
//             <span className="mr-2">Email us at</span>
//             <a
//               className="underline text-[#061126] hover:text-[#EFD05C] transition-colors"
//               href="mailto:contact@megacashluckybox.com"
//             >
//               contact@megacashluckybox.com
//             </a>
//           </p>
//         </div>

//         <p>
//           &copy; {new Date().getFullYear()} Copyright:
//           <Link
//             to="/"
//             className="underline text-[#061126] hover:text-[#EFD05C] transition-colors ml-1">
//             MegaCashBox
//           </Link>
//         </p>
//       </div>
//     </>
//   );
// }

// import { useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";

// export default function Footer() {
//   const footerStyles = " p-2 bg-[#EFD05C] text-center ";
//   const location = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to top on every route change
//   }, [location]);

//   return (
//     <>
//       <div className={footerStyles}>

//         <h2 className="font-bold text-xl my-2">Who are we?</h2>
//         <p className=" px-0 md:px-80">
//           Mega Cash Box is an exciting and interactive game that offers players
//           a thrilling experience of chance and reward.In this captivating game,
//           users are presented with six boxes, each potentially containing cash
//           or suprises.{" "}
//         </p>
//         <div className=" ">
//           <h2 className="font-bold text-xl my-2">Our partner</h2>
//           <div className="flex justify-center my-2">

//             <img src="caritas.svg" alt="caritas" className="mx-2 w-[82px]" />
//           </div>
//         </div>
//         <p className="mx-6 md:inline-block">
//           <Link
//             className="underline text-[#061126]"
//             to="/termsConditions">
//             Terms and Conditions
//           </Link>
//         </p>
//         <Link
//           className="underline text-[#061126]"
//           to="/privacypolicy">
//           Privacy Policy
//         </Link>
//       </div>
//       <div className="bg-white p-4 text-center font-bold">
//         <div className="flex flex-wrap justify-center items-center gap-4 mb-2">
//           <p className="flex items-center">
//             <span className="mr-2">Talk to us</span>
//             <a href="tel:+233303980440" className="text-[#061126] hover:text-[#EFD05C] transition-colors">
//               +233(0)303980440
//             </a>
//           </p>
//           <p className="flex items-center">
//             <span className="mr-2">Email us at</span>
//             <a
//               className="underline text-[#061126] hover:text-[#EFD05C] transition-colors"
//               href="mailto:contact@megacashluckybox.com"
//             >
//               contact@megacashluckybox.com
//             </a>
//           </p>
//         </div>

//         <p>
//           &copy; {new Date().getFullYear()} Copyright:
//           <Link
//             to="/"
//             className="underline text-[#061126] hover:text-[#EFD05C] transition-colors ml-1">
//             MegaCashBox
//           </Link>
//         </p>
//       </div>
//     </>
//   );
// }

import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on every route change
  }, [location]);

  return (
    <>
      <div className="bg-gradient-to-r from-[#EFD05C] to-[#BA9300] flex flex-col">
        <div className="flex flex-col  md:flex-row text-center items-center  justify-center md:text-start px-4 ju ">
          <div className="w-full md:w-1/2 md:order-2 md:px-5">
            {/* <h2 className="font-bold text-xl my-2 text-[#A70000]">
              Who are we?
            </h2>
            <p className="px-0 md:text-start">
              Mvuama bet D.R.C is an exciting and interactive game that offers
              players a thrilling experience of chance and reward. In this
              captivating game, users are presented with six boxes, each
              potentially containing cash or surprises.{" "}
            </p> */}
            <h2 className="font-bold text-xl my-2 text-[#A70000]">
              Qui sommes-nous ?
            </h2>
            <p className="px-0 md:text-start">
              Mvuama bet D.R.C est un jeu passionnant et interactif qui offre
              aux joueurs une expérience palpitante mêlant hasard et
              récompenses. Dans ce jeu captivant, les utilisateurs se voient
              présenter six boîtes, chacune pouvant contenir de l'argent ou des
              surprises.
            </p>
          </div>

          <div className=" my-2 min-w-[150px] ]">
            <img
              src="Mvuamafooter.png"
              alt="caritas"
              className="mx-2 w-[250px]  pl-4"
            />
          </div>
        </div>

        <div className=" md:flex text-black  gap-1 w-full">
          <div className="w-full h-px border-2 border-black my-4"></div>
          <div className="flex justify-center font-bold text-sm px-4">
            <div className="inline border-2 border-black rounded-full p-1 mb-1">
              18+
            </div>
            <p className="mx-6 md:inline-block md:text-nowrap">
              <Link className="underline " to="/termsConditions">
                {/* Terms and Conditions */}
                Termes et Conditions
              </Link>
            </p>
            <Link
              className="underline md:text-nowrap md:px-5 "
              to="/privacypolicy"
            >
              {/* Privacy Policy */}
              Politique de Confidentialité
            </Link>
          </div>
        </div>
      </div>
      {/*   
      <div className=" p-2 bg-[#F09015] text-start flex ">
        <div className="w-1/2">
          <h2 className="font-bold text-xl my-2 text-[#A70000]">Who are we?</h2>
          <p className=" px-0 ">
            Mvuama bet is an exciting and interactive game that offers
            players a thrilling experience of chance and reward. In this
            captivating game, users are presented with six boxes, each
            potentially containing cash or surprises.{" "}
          </p>
        </div>

        <div className=" w-1/2">
          <h2 className="font-bold text-xl my-2 text-[#A70000]">Our partner</h2>
          <div className="flex justify-start my-2 bg-[#A70000] w-[149px] h-[58px] rounded-3xl">
            <img
              src="icholalogo.svg"
              alt="caritas"
              className="mx-2 w-[119px] pl-4"
            />
          </div>
        </div>

        <div className="w-full">
          <div class="w-full  h-px bg-white my-4"></div>
          <div className="flex justify-center font-bold text-sm ">
            <span className="border-2 border-white  text-white rounded-full p-1">
              18+
            </span>
            <p className="mx-6 md:inline-block">
              <Link className="underline text-white" to="/termsConditions">
                Terms and Conditions
              </Link>
            </p>
            <Link className="underline  text-white" to="/privacypolicy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div> */}
      <div className="bg-white p-1 text-center font-bold md:flex gap-0.5 justify-center leading-10">
        <p className=" md:w-1/3 md:text-nowrap">Parlez-nous +243(0)837 541 948</p>
        {/* <p className=" md:w-1/3">Talk to us +243(0)837057147</p> */}
          <p className="w-full text-center">
            &copy; {new Date().getFullYear()} 
          </p>
        <p className=" md:w-1/3 md:text-nowrap ">
          {/* Email us at */}
          Écrivez-nous à
          <Link
            to="https://mail.google.com/mail/?view=cm&fs=1&to=info@megacashluckybox.com"
            className="underline text-[#061126] pl-1"
          >
             Mvuama MegaBox
          </Link>
          {/* <a
            className="underline  pl-3"
            href="https://mail.google.com/mail/?view=cm&fs=1&to=info@megacashluckybox.com"
          >

          </a> */}
        </p>
      </div>
    </>
  );
}
